import { getCookie } from "@origin-digital/origin-auth";

import { BRAZE_SEGMENT_COOKIE, LEGACY_MOVE_CONTENT } from "../consts";
import { isAuthenticated } from "./utils";

// Customer recognition changes the copy only. Every customer can book a move;
// the legacy `book` query parameter no longer controls the CTA.
export const getSalesButtonStatus = async (authenticated?: boolean) => {
  if (authenticated ?? (await isAuthenticated())) return true;
  return getCookie(BRAZE_SEGMENT_COOKIE) === "customers";
};

export const getLegacySalesButtonStatus = async (authenticated: boolean) => {
  const book = new URLSearchParams(window.location.search)
    .get("book")
    ?.toLowerCase();
  if (book === "true") return true;
  if (book === "false") return false;

  return (
    (await getSalesButtonStatus(authenticated)) &&
    !!LEGACY_MOVE_CONTENT.buttonLabelSales
  );
};
